import { Directive, EventEmitter, Output, ViewChild, inject } from '@angular/core';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ExportService } from 'src/app/shared/services/export.service';

/** Shared plumbing for the report tabs: loading messages, error toasts and exporting the results table. */
@Directive()
export abstract class ReportTabBase {
    /** Emits a loading message to show, or null to hide the loading dialog. */
    @Output() loadingChange = new EventEmitter<string | null>();

    @ViewChild('reportTable') reportTable: any;

    protected readonly messageService = inject(MessageService);
    private readonly exportService = inject(ExportService);

    protected startLoading(message: string): void {
        this.loadingChange.emit(message);
    }

    protected stopLoading(): void {
        this.loadingChange.emit(null);
    }

    protected showError(message: string): void {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
    }

    protected toReportDate(value: any): string {
        return (moment as any)(value).format('YYYY-MM-DD');
    }

    /** Exports the rendered results table to Excel, suffixing the file name with the current time. */
    protected exportTable(fileName: string): void {
        const tableElement = this.reportTable.el.nativeElement.querySelector('.p-datatable-table');
        this.exportService.exportTableToExcel(tableElement, `${fileName} ${new Date().toLocaleString()}`);
    }
}
